import {
  Flex,
  PrimaryButton,
  SafeAreaBottomSpacing,
  useSafeArea,
} from '@banhala/ui-kit';
import { useFilterListBottomSheetAtom } from '../../Provider/filterListBottomSheet/useFilterListBottomSheetAtom';
import { useNavigation, useRoute } from '@react-navigation/native';
import type { AnyObject } from '../../../../../../types';
import { bridge } from '../../../../../../utils';

type FooterProps = {
  closeBottomSheet: VoidFunction;
  totalCount: number;
  isLoading: boolean;
  onResetSlider: VoidFunction;
  logging: AnyObject;
  scrollToFilterList: VoidFunction;
  radioQueryName?: string;
};
export const Footer = ({
  closeBottomSheet,
  totalCount,
  isLoading,
  onResetSlider,
  logging,
  scrollToFilterList,
  radioQueryName,
}: FooterProps) => {
  const { filterListBottomSheetAtomValue, clearFilterListBottomSheet } =
    useFilterListBottomSheetAtom();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();
  const { params } = useRoute();
  const handleSubmit = () => {
    logClickApplyFilter(logging);
    const validParams = Object.entries(filterListBottomSheetAtomValue).reduce(
      (acc, [key, value]) => {
        if (value !== undefined && value !== null) {
          acc[key] = value;
        }
        return acc;
      },
      {} as Record<string, string>,
    );

    const paramsToUpdate = Object.keys(params ?? {}).reduce(
      (acc, key) => {
        if (
          key === 'next_token' ||
          key === 'screen_name' ||
          key === 'instanceId' ||
          key === radioQueryName
        ) {
          return acc;
        }
        acc[key] = validParams[key] ?? undefined;
        return acc;
      },
      { ...validParams } as Record<string, string | undefined>,
    );

    navigation.setParams(paramsToUpdate);
    closeBottomSheet();
    scrollToFilterList();
  };
  const handleReset = () => {
    clearFilterListBottomSheet();
    onResetSlider();
  };
  const { bottom } = useSafeArea();
  return (
    <>
      <Flex.Row
        position="absolute"
        height={80}
        bottom={bottom}
        left={0}
        right={0}
        padding={{ vertical: 12, horizontal: 12 }}
        gap={12}
        backgroundColor="white"
      >
        <PrimaryButton onPress={handleReset} color="gray" size="xlarge" outline>
          초기화
        </PrimaryButton>
        <Flex flex={1}>
          <PrimaryButton
            color="gray"
            variant="fill"
            size="xlarge"
            state={isLoading ? 'loading' : undefined}
            onPress={handleSubmit}
          >
            {`${totalCount.toLocaleString()} 개 결과보기`}
          </PrimaryButton>
        </Flex>
        <SafeAreaBottomSpacing />
      </Flex.Row>
    </>
  );
};

const logClickApplyFilter = (logging: AnyObject) => {
  bridge.logAnalyticsEvent({
    name: 'APPLY_FILTER',
    analytics: { ...logging.analytics, SCREEN: 'FILTER' },
    ably_only_log: logging.ably_only_log,
  });
};
